import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-engagement-home',
  templateUrl: './engagement-home.component.html',
  styleUrls: ['./engagement-home.component.css']
})
export class EngagementHomeComponent implements OnInit {

  carousel: string;

  constructor(private _dataService: DataService) {
    _dataService.roleInfoSource$.subscribe(value => this.carousel = value);
    console.log('Client Home Constructor ', this.carousel);
  }

  ngOnInit() {
  }
  
}
